export default __webpack_public_path__ + "static/The Home_Image 5_carousel 4@2x-3c64e6bfcd0ec1cf5570476d13c86afa.jpg";